import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "inline-flex items-center"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "(-)", -1);
const _hoisted_3 = [_hoisted_2];
import YouthPlayerModal from "@/modules/youth/components/YouthPlayerModal.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'YouthPlayerLink',
  props: {
    entity: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("a", {
        href: "#",
        class: "font-semibold text-blue-600",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.$refs.modal.show(), ["prevent", "stop"]))
      }, [_createTextVNode(_toDisplayString(__props.entity.shortName) + " ", 1), __props.entity.canSee('age') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode("(" + _toDisplayString(__props.entity.age) + ")", 1)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))]), _createVNode(YouthPlayerModal, {
        ref: "modal",
        entity: __props.entity
      }, null, 8, ["entity"])], 64);
    };
  }
});